import { IIconProps } from '~/types';
const GbpFlag = (props: IIconProps) => (
  <svg
    width={28}
    height={20}
    viewBox="0 0 28 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={28} height={20} rx={2} fill="#fff" />
    <mask
      id="a"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={28}
      height={20}
    >
      <rect width={28} height={20} rx={2} fill="#fff" />
    </mask>
    <g mask="url(#a)">
      <path fill="#0A17A7" d="M0 0h28v20H0z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m-1.282-1.916 11.949 8.06v-7.477h6.667v7.476l11.949-8.06 1.49 2.211-9.446 6.373H28v6.666h-6.674l9.448 6.373-1.491 2.21-11.95-8.06v7.477h-6.666v-7.476l-11.95 8.06-1.49-2.211 9.447-6.373H0V6.667h6.674L-2.773.294z"
        fill="#fff"
      />
      <path
        d="M18.668 6.332 31.333-2M20.014 13.698l11.354 7.653M8.005 6.31-3.838-1.67M9.29 13.605l-13.128 8.706"
        stroke="#DB1F35"
        strokeWidth={0.667}
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 12h12v8h4v-8h12V8H16V0h-4v8H0z"
        fill="#E6273E"
      />
    </g>
  </svg>
);
export default GbpFlag;
